export default __webpack_public_path__ + "static/media/vision-section-03.42935b03.webp";